import List from "@/components/list";
import vue from "@/main";
import { tableBaseProps } from '@/utils/common.js';
import './table.scss';

const Table = args => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const editMemberInfo = listeners["editMemberInfo"] || function () { };
  const updateGraduateInfo = listeners["updateGraduateInfo"] || function () { };
  const edit = listeners["edit"] || function () { };
  const goDetail = listeners["goDetail"] || function () { };
  const outSchoolDetail = listeners["outSchoolDetail"] || function () { };
  const updatePost = listeners["updatePost"] || function () { };
  // 删除人员
  function deleteStudent(enroll) {
    vue.$emit("deleteStudent", enroll);
  }
  // 结业
  function sendGraduation(enroll) {
    vue.$emit("sendGraduation", enroll.uuid);
  }
  // 取消结业
  function cancelGraduation(enroll) {
    vue.$emit("cancelGraduation", enroll.uuid);
  }
  // // 编辑班内职务
  // function updatePost(enroll) {
  //   vue.$emit("updatePost", enroll);
  // }
  // 删除班委人员
  function deletePost(enroll) {
    vue.$emit("deletePost", enroll);
  }
  //附件下载
  function handleDownloadFile(enroll) {
    if (enroll.attachment) {
      vue.$emit("downloadUserFile", enroll.uuid);
    }
  }
  // 设置优秀学员
  function setFineStu(enroll) {
    vue.$emit("setExcellent", enroll.uuid);
  }
  // 取消优秀学员
  function cancelFineStu(enroll) {
    vue.$emit("cancelExcellent", enroll.uuid);
  }

  const Deal = ({ props: { vo } }) => {
    const enroll = vo.row;
    const dealConf = [];
    dealConf.push([
      "icon-remove",
      "移除",
      () => deleteStudent(enroll),
      "classOffline:deleteStudent"
    ]);
    dealConf.push([
      "icon-graduation",
      "修改结业信息",
      () => updateGraduateInfo(enroll),
      "classOffline:graduation"
    ]);

    dealConf.push([
      "icon-post",
      "编辑班内职务",
      () => updatePost(enroll),
      "classOffline:post"
    ]);

    // dealConf.push([
    //   enroll.isExcellent ? "icon-cancel-excellent" : "icon-excellent",
    //   enroll.isExcellent ? "取消优秀学员" : "设置优秀学员",
    //   enroll.isExcellent ? () => cancelFineStu(enroll) : () => setFineStu(enroll),
    //   "classOffline:excellent"
    // ]);

    dealConf.push([
      "icon-edit",
      "修改学员信息",
      () => { editMemberInfo(enroll) },
      "classOffline:post"
    ])

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const UnitPosition = ({ props: { vo } }) => {
    const unitPosition = vo.row.unitPosition ? vo.row.unitPosition : "--";
    return <span>{unitPosition}</span>;
  };

  const GraduationStatusItem = ({ props: { vo } }) => {
    let row = vo.row;
    return <span>{row.graduationStatusName}</span>
  }

  const TrainDaysItem = ({ props: { vo } }) => {
    let row = vo.row;
    // if (!row.isParty) {
    //   return <span class="blue-char" onClick={() => edit(row, 2, "修改培训天数")}>{row.trainDays}</span>
    // } else {
    return <span>{row.trainDays}</span>
    // }
  }

  const ClassPushTime = ({ props: { vo } }) => {
    const enrollPushTime = vo.row.enrollPushTime
      ? vo.row.enrollPushTime
      : "--";
    return <span>{enrollPushTime}</span>;
  };

  const UserName = ({ props: { vo } }) => {
    const row = vo.row;
    return (
      <div class="base-hover-char" onClick={() => goDetail(row)}>
        {row.userName}
      </div>
    );
  };

  const GradeStatus = ({ props: { vo } }) => {
    const row = vo.row;
    const flag = row.graduationStatus === 2
    return <div class={flag ? "base-hover-char" : ""} onClick={() => {
      flag && outSchoolDetail(row)
    }}>
      {row.graduationStatusName}
    </div>

  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      ...tableBaseProps("姓名", "userName", "80"),
      render: (vo) => <UserName vo={vo} />,
    },
    
  ];

  if (props.childNum > 0) {
    AccountTableConfig.push({
      label: "所属小班",
      prop: "smallClassName",
      minWidth: "90",
      showOverflowTooltip: true
    })
  }
  AccountTableConfig.push(tableBaseProps("工作单位", "deptName", "m150"));
  AccountTableConfig.push({
    ...tableBaseProps("单位及职务", "unitPosition", "m150"),
    render: vo => <UnitPosition vo={vo} />
  })
  AccountTableConfig.push(tableBaseProps("浙政钉绑定状态", "zzdBindStatusStr", "m100"))

  if (props.isAttachment == 1) {
    AccountTableConfig.push({
      label: "报名附件",
      width: "140",
      showOverflowTooltip: true,
      render: vo => (
        <el-button
          class="no-padding"
          size="small"
          type="text"
          v-permission="classOffline:downloadBatch"
          onClick={() => handleDownloadFile(vo.row)}
        >
          {vo.row.attachmentName}
        </el-button>
      )
    });
  }

  AccountTableConfig.push(tableBaseProps("班内职务", "classPostName", "m100"))
  if (props.onlineLearn == 1) {
    AccountTableConfig.push({
      ...tableBaseProps("在线课件学习情况", "onlineLearnStatusStr", "150"), 
      renderHeader: () => {
        return (
          <div class="table-row">
            <span>在线课件学习情况</span>
            <el-tooltip class="item" effect="dark" content="温馨提示：如果中网院在线学习情况未及时同步，请检查专题班名称是否与中网院一致。" placement="top-start">
              <i class="el-icon-warning" style="font-size: 16px"/>
            </el-tooltip>
          </div>
        );
      },
    });
  }
  AccountTableConfig.push(tableBaseProps("优秀学员", "isExcellentName", "80"));
  // 党校不让编辑
  AccountTableConfig.push({
    ...tableBaseProps("结业状态", "graduationStatusName", "80"),
    render: vo => <GradeStatus vo={vo} />
  });
  AccountTableConfig.push({
    label: "培训天数",
    prop: "trainDays",
    width: "100",
    showOverflowTooltip: true,
    render: vo => <TrainDaysItem vo={vo} />,
  });
  AccountTableConfig.push({
    label: "房间号",
    prop: "roomNumber",
    width: "100",
    showOverflowTooltip: true
  });
  if (props.isParty == 1) {
    AccountTableConfig.push({
      label: "党校同步状态",
      prop: "enrollPushStatusName",
      width: "100",
      showOverflowTooltip: true
    });
    AccountTableConfig.push({
      label: "上次同步时间",
      prop: "enrollPushTime",
      width: "160",
      showOverflowTooltip: true,
      render: (vo) => <ClassPushTime vo={vo} />,
    });
  }
  AccountTableConfig.push({
    label: "操作",
    fixed: "right",
    width: "150",
    render: vo => <Deal vo={vo} />
  });
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
